<div class="get-resource-definition">
  <app-popup-top-line></app-popup-top-line>
  <div class="get-resource-definition-header">
    <div class="title">{{ title }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="closeWindow()" />
  </div>

  <div class="get-resource-definition-body" *ngIf="!waitingForResponse && noDataText.value === ''">
    <div>
      <div class="get-resource-definition-body-raw-json-container">
        <div class="raw-json-field-description">
          {{ description }}
        </div>

        <div class="raw-json-field-value-container">
          <app-copy-button
            class="raw-json-field-copy-button"
            [successPopupPosition]="popupPosition.Left"
            [value]="flowRunsModels[selectedFlowRunIndex].flowRunString"
          ></app-copy-button>
          <pre class="raw-json-field-value" disabled="true">{{
            flowRunsModels[selectedFlowRunIndex].flowRunString
          }}</pre>
        </div>
        <div class="paginator">
          <div
            class="paginator-arrow"
            [ngClass]="selectedFlowRunIndex === 0 ? 'disabled' : 'enabled'"
            (click)="prevItem($event)"
          >
            <div>Prev</div>
            <img src="assets/images/arrows/empty-arrow-left.svg" />
          </div>
          <div class="paginator-arrow-page">
            <div class="paginator-arrow-page-item">
              {{ selectedFlowRunIndex + 1 }}
            </div>
            <div class="paginator-arrow-page-item">-</div>
            <div class="paginator-arrow-page-item">
              {{ flowRunsModels.length }}
            </div>
          </div>
          <div
            class="paginator-arrow"
            [ngClass]="selectedFlowRunIndex === flowRunsModels.length - 1 ? 'disabled' : 'enabled'"
            (click)="nextItem($event)"
          >
            <img src="assets/images/arrows/empty-arrow-right.svg" />
            <div>Next</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="missing-resource-definition" *ngIf="!waitingForResponse && noDataText.value !== ''">
    <app-no-data [tableNotFoundText]="noDataText.value"></app-no-data>
  </div>
</div>
<div class="get-resource-definition-spinner" *ngIf="waitingForResponse">
  <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
